// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"film-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M7 3L7 21H17L17 3L7 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 3V21M17 3V21M3 7H7M3 17H7M21 7H17M21 17H17M3 12H21M3 21V3H21V21H3Z","strokeWidth":"props.strokeWidth"}}]}]};

const Film1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'film-1',
    ref,
    icon: element,
  },
));

Film1Icon.displayName = 'Film1Icon';

export default Film1Icon;
